export default __webpack_public_path__ + "static/media/template6.8d796963.png";